import { call } from "redux-saga/effects"
import { map } from "lodash"
import { postRaw } from "."
import { getToken } from "./token"

export default function* uploadFiles(accountId, resourceId, files, options = {}) {
  const data = new FormData()

  for (const f of files) {
    const file = f.file
    const { name } = file
    data.append(name, file, name)
  }

  // Transform options to query params
  const queryParams = new URLSearchParams(map(options, (value, key) => [key, value])).toString()

  const token = yield call(getToken)
  const headers = { "X-OmegaPoint-Code": token }
  const filePaths = yield call(postRaw, `/api/${accountId}/${resourceId}/upload?${queryParams}`, data, { headers })

  return filePaths
}
